/** Emphasise the matched substring in a search result row — the reference's
 *  omnisearch does exactly this, and it's what makes a 3-row section scannable.
 *  A <mark> at low brand-tint opacity, not a colour change: the row keeps at
 *  most one saturated accent, and the first cut's amber wash read as muddy
 *  brown on the dark theme (Kai's screenshot). */
export function Highlight({ text, term }: { text: string; term: string }) {
  const t = term.trim();
  if (!t) return <>{text}</>;
  const i = text.toLowerCase().indexOf(t.toLowerCase());
  if (i === -1) return <>{text}</>;
  return (
    <>
      {text.slice(0, i)}
      <mark className="rounded-sm bg-brand/20 px-0.5 font-medium text-inherit">
        {text.slice(i, i + t.length)}
      </mark>
      {text.slice(i + t.length)}
    </>
  );
}
